import React, * as react from 'react';
import { Link } from 'gatsby';
import Theme from './theme';
import { AiOutlineArrowDown } from "react-icons/ai"
import '../styles/main.scss'

const Dropdown = ({ callbackFromParent }) => {
  const node = react.useRef();
  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      callbackFromParent(true);
      return;
    }
    // outside click
    callbackFromParent(false);
  };

  react.useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  return (
    <div ref={node}>
      <div>
        <h4>Life Style</h4>
        <AiOutlineArrowDown/>
        <div onClick={() => callbackFromParent(false)}>
          <Link to="/fashion">Fashion</Link>
        </div>
        <div onClick={() => callbackFromParent(false)}>
          <Link to="/trips">Trips</Link>
        </div>
        <div onClick={() => callbackFromParent(false)}>
          <Link to="/experiences">Experiences</Link>
        </div>
        <div onClick={() => callbackFromParent(false)}>
          <Link to="/art">Art</Link>
        </div>
      </div>
      <div item xs={12} sm={4} md={4}>
        <h4><Link to="/editorials">Editorials</Link></h4>
      </div>
      <div>
        <h4><Link to="/events">PR / Events</Link></h4>
      </div>
  
    </div>
  );
};

const NavBar = () => {
  const [listOpen, setListOpen] = react.useState(false);

  const myCallback = (listOpen) => {
    setListOpen(listOpen);
  };

  return (
    <div className="navbar">
      <ul>
        <li onClick={() => setListOpen(!listOpen)}>Portfolio</li>
        <li onClick={() => setListOpen(false)}>
          <Link to="/connect">Connect</Link>
        </li>
        <li onClick={() => setListOpen(false)}>
          <Link to="/about">About</Link>
        </li>
        <li className="nav_theme-icon"><Theme/></li>
      </ul>
      
      <div className="dropdown">{listOpen ? <Dropdown callbackFromParent={myCallback} /> : null}</div>
    </div>
  );
};
export default NavBar;

//https://medium.com/@akhgupta/make-a-navbar-from-scratch-with-dropdown-outside-click-detection-and-other-features-in-react-8707a0a91fb0